import React from 'react';

import { ButtonGroup, MessageText, ResponseRatingContainer } from './Message.styled';
import Button from 'components/Buttons/NewButton';
import { analytics } from 'utilities/analytics';

import { Props, PRESET_USER_RESPONSES } from './Message.types';
import { CreateMessage } from '../Conversation/Conversation.types';
import { MessageFile } from '../MessageFile/MessageFile';

export const Message = ({ message, conversationId, onSend, latestMessage }: Props): JSX.Element => {
  const sendMessage = (body: string) => {
    const parameters: CreateMessage = {
      conversationId: Number(conversationId),
      body
    };
    onSend(parameters);
  };

  return (
    <>
      {message.ai ? (
        <MessageText key={message.id} fromPatient={message.fromPatient} $flex $isAi={message.ai}>
          <span dangerouslySetInnerHTML={{ __html: message.body }} />
          <ResponseRatingContainer $latestMessage={latestMessage}>
            {latestMessage && (
              <ButtonGroup>
                <Button
                  text={PRESET_USER_RESPONSES.POSITIVE}
                  onClick={() => {
                    analytics.track(analytics.EVENTS.FAQ_RECOMMENDATION_ACCEPTED, {
                      conversationId,
                      messageId: message.id
                    });
                    sendMessage(PRESET_USER_RESPONSES.POSITIVE);
                  }}
                />
                <Button
                  text={PRESET_USER_RESPONSES.NEGATIVE}
                  onClick={() => {
                    analytics.track(analytics.EVENTS.FAQ_RECOMMENDATION_REJECTED, {
                      conversationId,
                      messageId: message.id
                    });
                    sendMessage(PRESET_USER_RESPONSES.NEGATIVE);
                  }}
                />
              </ButtonGroup>
            )}
          </ResponseRatingContainer>
        </MessageText>
      ) : (
        <MessageText key={message.id} fromPatient={message.fromPatient}>
          <span dangerouslySetInnerHTML={{ __html: message.body }} />
        </MessageText>
      )}

      {message.attachments?.map((attachment, index) => {
        return (
          <MessageFile key={index} attachment={attachment} fromPatient={message.fromPatient} />
        );
      })}
    </>
  );
};
